module.exports = __webpack_public_path__ + "static/media/tunja.01b6f78f.jpeg";